import { RemoteGetAllPersonCompletedEvaluations } from 'data/usecases';
import { GetAllPersonCompletedEvaluationsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPersonCompletedEvaluations } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllPersonCompletedEvaluations =
  (): GetAllPersonCompletedEvaluationsUseCaseInterface =>
    new RemoteGetAllPersonCompletedEvaluations(
      makeApiUrlPersonCompletedEvaluations(),
      makeAxiosHttpClient(),
    );
